import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { showModal } from 'appSrc/redux/actions';
import { parseYouTubeUrl, convertYouTubeIdToImg } from 'appSrc/utils/video';
import { Icon } from 'appSrc/components/UI';
import style from './styles/style.module.css';

class ReviewSubcard extends PureComponent {
    playMovie = () => {
        const { review } = this.props;
        var video = review.video_url;
        var videoId;
        if( video ) {

            const movieMetaData = {
                attached_to: 'review_video',
                attached_id: review.id,
                video_author_id: review.userid,
            };

            videoId = parseYouTubeUrl( video );
            this.props.playMovie( videoId, movieMetaData );
        }
    }
    render() {
        const { review } = this.props;
        var video = review.video_url;
        var videoId, videoImage;
        if( video ) {
            videoId = parseYouTubeUrl( video );
            videoImage = convertYouTubeIdToImg( videoId, 'med/jpg' );
        }

        const className = `${ style.subCard } ${ style.reviewCard } ${ this.props.className }`.trim();

        return (
            <div className={ className } onClick={ this.playMovie } data-clickable={ !!videoId }>
                <div className={ style.text }>
                    <div className={ style.type }>Watch Review</div>
                </div>
                { video &&
                    <div className={ style.video }>
                        <img className={ style.videoImage } src={ videoImage } />
                        <Icon source='customSvg' icon='play-large' className={ style.playIcon }
                        size={ this.props.size } />
                    </div>
                }
            </div>
        );
    }
}
ReviewSubcard.defaultProps = {
    review: {},
    className: '',
};
ReviewSubcard.propTypes = {
    review: PropTypes.object.isRequired,
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        playMovie: ( youtubeId, metaData ) => {
            dispatch( showModal( 'movieTheater', { youtubeId: youtubeId, metaData: metaData } ) );
        },
    };
};

export default connect( null, mapDispatchToProps )( ReviewSubcard );
